export function getDayOfWeek(): string {
  const date = new Date();

  return date.toLocaleString('en-us', { weekday: 'long' }).toLowerCase();
}

export function getPartOfDay(): string {
  let partOfDay = '';
  const date = new Date();
  const hours = date.getHours();

  if (hours >= 3 && hours < 5) {
    partOfDay = 'night';
  }

  if (hours >= 5 && hours < 12) {
    partOfDay = 'morning';
  } else if (hours >= 12 && hours < 20) {
    partOfDay = 'day';
  } else if (hours >= 20 && hours < 3) {
    partOfDay = 'evening';
  }

  return partOfDay;
}
